import GridCard from '@Guidelines/Component/GridCard';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

/**
 * The card's own box, not its shell: `position: relative` anchors the title link's full-card overlay
 * (see `SubjectCardTitle`), `:hover` and `:has(a:focus-visible)` read the card's hairline and focus ring.
 * Passed to `GridCard`'s `css` prop, which merges into the shell's own rule — padding, radius, surface
 * and border stay `GridCard`'s property and are never redeclared here.
 */
const cardBoxStyle = css`
	position: relative;
	transition: border-color ${theme.motion.duration};

	&:hover {
		border-color: ${theme.colors.borderStrong};
	}

	/* The overlay carries the pointer, so the focus ring has to be drawn by the card it covers. */
	&:has(a:focus-visible) {
		outline: 2px solid ${theme.colors.accent};
		outline-offset: 2px;
	}
`;

type Props = {
	readonly trackCount: number;
	readonly rowGap: string;
	readonly children: React.ReactNode;
};

/** The box shared by the list cards of every dossier type. */
const SubjectCardFrame: React.FC<Props> = ({ trackCount, rowGap, children }) => {
	return (
		<GridCard css={cardBoxStyle} trackCount={trackCount} rowGap={rowGap}>
			{children}
		</GridCard>
	);
};

export default SubjectCardFrame;
